const styles = () => ({
    container: {
        height: '38px',
        color: '#FFFFFF',
        fontFamily: 'VodafoneRg-Regular',
        fontSize: '18px',
        display: 'inline-flex',
        minWidth: '150px',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 8px',
        marginLeft: '0px',
        marginRight:'8px',
        marginBottom:'8px',
        cursor: 'pointer',
        borderRadius: '22px',
        border:'0px',
        backgroundColor:'#6d45ff',
           
    },
    btnDisable:{
        opacity:'0.5',
        pointerEvents:'none',
        'pointer-events':'none'
        // PointerEvents:'none'
        // cursor:'not-allowed'
    }
})
export default styles